import { defineMessages } from 'react-intl';

export default defineMessages({

  areYouClaimingForPropertyDamage: {
    id: 'fastCover.propertyDamageStep.areYouClaimingForPropertyDamage',
    defaultMessage: 'Are you claiming for Property Damage?',
  },

  cityOrTown: {
    id: 'fastCover.propertyDamageStep.cityOrTown',
    defaultMessage: 'City or Town',
  },

  country: {
    id: 'fastCover.propertyDamageStep.country',
    defaultMessage: 'Country',
  },

  state: {
    id: 'fastCover.propertyDamageStep.state',
    defaultMessage: 'State',
  },

  postalCode: {
    id: 'fastCover.propertyDamageStep.postalCode',
    defaultMessage: 'Postal Code',
  },

  phoneNumber: {
    id: 'fastCover.propertyDamageStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  currency: {
    id: 'fastCover.propertyDamageStep.currency',
    defaultMessage: 'Currency',
  },

  yes: {
    id: 'fastCover.propertyDamageStep.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.propertyDamageStep.no',
    defaultMessage: 'No',
  },

  addItem: {
    id: 'fastCover.propertyDamageStep.addItem',
    defaultMessage: 'Add Item',
  },

  itemWithIdx: {
    id: 'fastCover.propertyDamageStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  item: {
    id: 'fastCover.propertyDamageStep.item',
    defaultMessage: 'Item',
  },

  isRequired: {
    id: 'fastCover.propertyDamageStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },

  checkEventDate: {
    id: 'fastCover.propertyDamageStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },


  travelSupplierOrProviderInformation: {
    id: 'fastCover.propertyDamageStep.travelSupplierOrProviderInformation',
    defaultMessage: 'Travel Supplier/Provider Information',
  },

  propertyManagerInformation: {
    id: 'fastCover.propertyDamageStep.propertyManagerInformation',
    defaultMessage: 'Property Manager Information',
  },

  nameOfTourOperatorOrCruiseOrLineOrAirline: {
    id: 'fastCover.propertyDamageStep.travelSupplierOrProviderInformation',
    defaultMessage: 'Name of Tour Operator/Cruise Line/Airline you were traveling with:',
  },

  lossInformation: {
    id: 'fastCover.propertyDamageStep.lossInformation',
    defaultMessage: 'Loss Information',
  },

  otherInsuranceAuthorization: {
    id: 'fastCover.propertyDamageStep.otherInsuranceAuthorization',
    defaultMessage: 'OTHER INSURANCE / Authorisation:',
  },

  companyName: {
    id: 'fastCover.propertyDamageStep.companyName',
    defaultMessage: 'Company Name',
  },

  address: {
    id: 'fastCover.propertyDamageStep.address',
    defaultMessage: 'Address',
  },

  typeOfPolicy: {
    id: 'fastCover.propertyDamageStep.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },

  policy: {
    id: 'fastCover.propertyDamageStep.policy',
    defaultMessage: 'Policy',
  },

  contact: {
    id: 'fastCover.propertyDamageStep.contactF',
    defaultMessage: 'Contact',
  },

  phone: {
    id: 'fastCover.propertyDamageStep.phone',
    defaultMessage: 'Phone',
  },

  origination: {
    id: 'fastCover.propertyDamageStep.origination',
    defaultMessage: 'Origination',
  },

  flightNumber: {
    id: 'fastCover.propertyDamageStep.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.propertyDamageStep.airCarrier',
    defaultMessage: 'AirCarrier',
  },

  destination: {
    id: 'fastCover.propertyDamageStep.destination',
    defaultMessage: 'Destination',
  },

  companyNameLoss: {
    id: 'fastCover.propertyDamageStep.companyNameLoss',
    defaultMessage: 'Expense Description (airline/hotel/cruse/travel agent/ect.)',
  },

  amountPaidLoss: {
    id: 'fastCover.propertyDamageStep.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.propertyDamageStep.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.propertyDamageStep.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.propertyDamageStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  delayInformationWithIdx: {
    id: 'fastCover.propertyDamageStep.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },

  fromWhom: {
    id: 'fastCover.propertyDamageStep.fromWhom',
    defaultMessage: 'It so, from whom?',
  },

  dateReimbursementReceived: {
    id: 'fastCover.propertyDamageStep.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  estimatedValue: {
    id: 'fastCover.propertyDamageStep.estimatedValue',
    defaultMessage: 'Estimated Value',
  },

  lossInformationWithIdx: {
    id: 'fastCover.propertyDamageStep.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  propertyName: {
    id: 'fastCover.propertyDamageStep.propertyName',
    defaultMessage: 'Property Name',
  },
  propertyAddress: {
    id: 'fastCover.propertyDamageStep.propertyName',
    defaultMessage: 'Property Address',
  },
  unitOwnerName: {
    id: 'fastCover.propertyDamageStep.unitOwnerName',
    defaultMessage: 'Unit Owner Name:',
  },
  unitTelephoneNumber: {
    id: 'fastCover.propertyDamageStep.propertyName',
    defaultMessage: 'Unit Owner’s Telephone Number:',
  },
  numberOfPeopleInUnit: {
    id: 'fastCover.propertyDamageStep.numberOfPeopleInUnit',
    defaultMessage: 'Number of People in Unit',
  },
  describeIndicentThatCausedTheDamage: {
    id: 'fastCover.propertyDamageStep.propertyName',
    defaultMessage: 'Describe indicent that caused the damage',
  },
  schoolName: {
    id: 'fastCover.propertyDamageStep.schoolName',
    defaultMessage: 'School Name',
  },
  dateOfLoss: {
    id: 'fastCover.propertyDamageStep.dateOfLoss',
    defaultMessage: 'Date Of Loss',
  },

});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.PropertyDamageStep/messages.js